/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import DomainModel from 'cio/models/domain';
import { tracked } from '@glimmer/tracking';
import AnalyticsService from 'cio/services/analytics';

interface SendingDomainsDomainManageArgs {
  domain: DomainModel;
  hasCustomMailServers: boolean;
}

export enum SendingDomainsTab {
  Authentication = 'Authentication',
  LinkTracking = 'Link Tracking',
  MailServers = 'Mail Servers',
}

export default class SendingDomainsDomainManage extends Component<SendingDomainsDomainManageArgs> {
  @service analytics!: AnalyticsService;

  tabs = SendingDomainsTab;

  @tracked currentTab: SendingDomainsTab = SendingDomainsTab.Authentication;

  @action
  visitTab(tab: SendingDomainsTab) {
    this.currentTab = tab;
    this.analytics.track(
      'email',
      (
        {
          [SendingDomainsTab.Authentication]: 'deliverability_domain_viewed',
          [SendingDomainsTab.LinkTracking]: 'link_tracking_domain_viewed',
          [SendingDomainsTab.MailServers]: 'mail_servers_domain_viewed',
        } as const
      )[tab],
    );
  }

  constructor(owner: unknown, args: SendingDomainsDomainManageArgs) {
    super(owner, args);
    this.visitTab(SendingDomainsTab.Authentication);
  }
}
